import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import PaginatedTable from '../common/containers/PaginatedTable';

const { Text } = Typography;

/** Form Table Component */
export default function FormsTable({
  title,
  data,
  columns,
  onClickRow,
  expandable,
  loading = false,
  style = {},
  rowSelectionProps = {},
  onHeaderRow,
  isHomePreview = false,
}) {
  return (
    <>
      {title && (
        <Text style={{ fontFamily: 'roboto-medium', fontSize: 18, ...style }}>{ title }</Text>
      )}
      <div
        className={isHomePreview ? 'file-list-container forms-home-table-container' : 'file-list-container'}
      >
        <PaginatedTable
          dataSource={data}
          columns={columns}
          scrollOffset={260}
          size="small"
          rowClassName="file-table-row"
          onRow={(record) => ({
            onClick: () => onClickRow(record),
          })}
          rowKey="id"
          expandable={expandable}
          loading={loading}
          onHeaderRow={onHeaderRow}
          disableVerticalScroll={isHomePreview}
          tableLayout={isHomePreview ? 'fixed' : undefined}
          {...rowSelectionProps} // eslint-disable-line react/jsx-props-no-spreading
        />
      </div>
    </>
  );
}

FormsTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    templateId: PropTypes.string,
    templateName: PropTypes.string,
    createdAt: PropTypes.number,
    lastUpdated: PropTypes.number,
    users: PropTypes.arrayOf(PropTypes.string), // array of user id
    status: PropTypes.string,
    companyId: PropTypes.string,
  })),
  columns: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    dataIndex: PropTypes.string,
    width: PropTypes.number,
    align: PropTypes.string,
  })),
  onClickRow: PropTypes.func.isRequired,
  expandable: PropTypes.shape({
    expandedRowRender: PropTypes.func,
    rowExpandable: PropTypes.func,
  }),
  loading: PropTypes.bool,
  style: PropTypes.shape({}),
  rowSelectionProps: PropTypes.shape({}),
  onHeaderRow: PropTypes.func,
  isHomePreview: PropTypes.bool,
};

FormsTable.defaultProps = {
  title: '',
  data: [],
  columns: [],
  expandable: {},
  loading: false,
  style: {},
  rowSelectionProps: {},
  onHeaderRow: () => ({}),
  isHomePreview: false,
};
